import { render, staticRenderFns } from "./SalaryPeriodList.vue?vue&type=template&id=1f2d3acf&scoped=true"
import script from "./SalaryPeriodList.vue?vue&type=script&lang=js"
export * from "./SalaryPeriodList.vue?vue&type=script&lang=js"
import style0 from "./SalaryPeriodList.vue?vue&type=style&index=0&id=1f2d3acf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2d3acf",
  null
  
)

export default component.exports